export default __webpack_public_path__ + "static/media/ic-openModeWhite.cef012a3.svg";